"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const constant_1 = require("@/constants/constant");
const useApiService_1 = require("@/api/useApiService");
const Shared_1 = require("@/components/styled-controls/Shared");
const Layout_1 = __importDefault(require("@/components/organisms/Layout"));
const Input_1 = require("@/components/styled-controls/Input");
const TextInput_1 = __importDefault(require("@/components/atoms/TextInput"));
const ValidationHelper_1 = require("@/helpers/ValidationHelper");
const PushFormSuccessValuestoDataLayer_1 = require("@/helpers/PushFormSuccessValuestoDataLayer");
const react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3"); // Import Google reCAPTCHA v3
const EmailRegistrationForm = ({ isCaptchaAuthorized }) => {
    const { setStep, setUserData, appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { loginUrl, subscriptionApiUrl, analyticsPrefix, registrationSource, currentEnvironment, registrationStepCopy, onEmailSuccessfulEntry, plgThresholdToShowPopup, } = appProps;
    const [email, setEmail] = (0, react_1.useState)('');
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(registrationSource !== 'MarketingPages'); // As onboarding from marketing page needs the CTA to be active, we do not want the button to be disabled by default
    /**
     * State variable for tracking whether the form has been submitted.
     * This is used to control the display of validation messages.
     * Validation messages are only displayed once the form has been submitted.
     * This helps to improve the user experience by not showing validation errors before the user has had a chance to complete the form.
     */
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const [validationError, setValidationError] = (0, react_1.useState)('');
    const { userService, handleResponse } = (0, useApiService_1.useApiService)();
    const { executeRecaptcha } = (0, react_google_recaptcha_v3_1.useGoogleReCaptcha)(); // Use Google reCAPTCHA v3
    /**
     * Handles the success response from the API call.
     * Otherwise, sets a validation error message indicating that something went wrong.
     * @param data - The response data from the API call.
     */
    const successHandler = (data) => {
        if (data.ShouldRedirect && typeof globalThis !== 'undefined') {
            const pageViewEvents = globalThis.dataLayer.filter((event) => event.event === 'em.pageView');
            const latestPageViewEvent = pageViewEvents[pageViewEvents.length - 1];
            const ampltudeAnalyticsData = {
                redirectReason: data.RedirectReason,
                redirectUrl: data.Redirect,
                email: email,
                ...latestPageViewEvent,
            };
            globalThis
                .iiAna('track', constant_1.DATA_ANALYTICS_TAG.EMAIL_REGISTRATION.REDIRECT(analyticsPrefix), ampltudeAnalyticsData)
                .then(() => {
                globalThis.location.href = data.Redirect;
            }); //redirectReason should come in in snake_case format
            // Means its not eligible for freemium registration and should follow existing registration flow
        }
        else if (data.HasError) {
            const pageViewEvents = globalThis.dataLayer.filter((event) => event.event === 'em.pageView');
            const latestPageViewEvent = pageViewEvents[pageViewEvents.length - 1];
            const ampltudeAnalyticsData = {
                captchaErrorMessage: data.ErrorMessage,
                captchaErrorCode: data.ErrorCode,
                email: email,
                userAgent: globalThis.navigator.userAgent,
                ...latestPageViewEvent,
            };
            globalThis
                .iiAna('track', constant_1.DATA_ANALYTICS_TAG.EMAIL_REGISTRATION.CAPTCHA_ERROR(analyticsPrefix), ampltudeAnalyticsData)
                .then(() => {
                if (['development', 'staging', 'local'].includes(currentEnvironment)) {
                    console.error('API Error: ', data.ErrorCode);
                }
            }); //redirectReason should come in in snake_case format
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
        else {
            setUserData((prevData) => ({ ...prevData, email }));
            (0, PushFormSuccessValuestoDataLayer_1.pushFormSuccessValuestoDataLayer)({ 'form-name': `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-registration`, email: email }); // push values to DL only after successful submission
            if (onEmailSuccessfulEntry) {
                onEmailSuccessfulEntry().then(() => {
                    setStep('passwordAndCode');
                });
            }
            else {
                setStep('passwordAndCode');
            }
        }
    };
    /**
     * Retrieves the appropriate URL based on whether captcha is required or not
     * @returns The URL string.
     */
    const getUrlForEmailRegistration = () => {
        return isCaptchaAuthorized
            ? `${subscriptionApiUrl}/freemiumstandaloneregister`
            : `${subscriptionApiUrl}/freemiumregister`;
    };
    /**
     * Retrieves the reCAPTCHA token if required.
     * Returns the token if successful, otherwise returns null.
     */
    const getRecaptchaToken = async () => {
        if (!isCaptchaAuthorized)
            return null;
        try {
            if (!executeRecaptcha) {
                return null;
            }
            const token = await executeRecaptcha('email_registration');
            return token;
        }
        catch (error) {
            return null;
        }
    };
    /**
     * Handles the next step in the email registration process.
     * If the form is valid, it submits the email to the userService for registration.
     * If successful, it calls the successHandler function.
     */
    const handleNext = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true);
        setIsSubmitted(true);
        if (!isValid(email)) {
            setIsButtonDisabled(false);
            return;
        }
        const recaptchaToken = await getRecaptchaToken();
        if (isCaptchaAuthorized && !recaptchaToken) {
            setIsButtonDisabled(false);
            return;
        }
        await submitEmail(recaptchaToken);
    };
    /**
     * Submits the email to the userService for registration.
     * If successful, it calls the successHandler function.
     * Otherwise, sets a validation error message indicating that something went wrong.
     */
    const submitEmail = async (recaptchaToken) => {
        try {
            const emailRegistrationUrl = getUrlForEmailRegistration();
            const response = await userService.submitEmail(emailRegistrationUrl, email, recaptchaToken);
            await handleResponse(response, successHandler, null);
        }
        catch (error) {
            if (['development', 'staging', 'local'].includes(currentEnvironment)) {
                console.error(error);
            }
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
        finally {
            setIsButtonDisabled(false);
        }
    };
    /**
     * Handles and validates the email input client side.
     * Returns true if the email is valid, otherwise sets a validation error message and returns false.
     */
    const isValid = (emailValue) => {
        const [isValidEmail, errorMessage] = (0, ValidationHelper_1.isEmailValid)(emailValue, constant_1.EXCLUDED_DOMAINS);
        if (!isValidEmail) {
            setValidationError(errorMessage);
            return false;
        }
        // Clear any previous error messages if the email is valid
        setValidationError('');
        return true;
    };
    const headerText = registrationStepCopy?.EMAIL_REGISTRATION?.TITLE || constant_1.HEADER_TEXTS.EMAIL_REGISTRATION.TITLE;
    const subHeaderText = registrationStepCopy?.EMAIL_REGISTRATION?.HASSUBTITLE
        ? registrationStepCopy.EMAIL_REGISTRATION.SUBTITLE ||
            constant_1.HEADER_TEXTS.EMAIL_REGISTRATION.subtitle(plgThresholdToShowPopup)
        : '';
    const buttonText = registrationStepCopy?.EMAIL_REGISTRATION?.CTA || 'Continue';
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: headerText, subHeaderText: subHeaderText },
        ' ',
        react_1.default.createElement(Input_1.RegistrationForm, { onSubmit: (e) => handleNext(e), id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-registration`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-registration` },
            react_1.default.createElement(TextInput_1.default, { type: "email", value: email, onChange: (value) => {
                    setEmail(value);
                    setIsButtonDisabled(false);
                    if (isSubmitted) {
                        isValid(value);
                    }
                }, validationError: validationError, placeholder: constant_1.PLACEHOLDER_TEXTS.EMAIL_REGISTRATION.EMAIL, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-email-registration`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-email-registration` }),
            react_1.default.createElement(Shared_1.ButtonContainer, null,
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "default", dataAnalytics: constant_1.DATA_ANALYTICS_TAG.EMAIL_REGISTRATION.CONTINUE(analyticsPrefix), size: "m", disabled: isButtonDisabled, "$isDisabled": isButtonDisabled, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-continue-registration`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-continue-registration` }, buttonText))),
        react_1.default.createElement(Shared_1.Disclaimer, null, constant_1.EMAIL_DISCLAIMER),
        react_1.default.createElement(Shared_1.HaveAnAccountWrapper, null,
            react_1.default.createElement(Shared_1.StepPrompt, null, "Have an account?"),
            react_1.default.createElement(Shared_1.StyledSignIn, { href: loginUrl, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.EMAIL_REGISTRATION.SIGN_IN(analyticsPrefix), size: "default", target: "_blank", id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.ATAG}-signin-registration`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.ATAG}-signin-registration` }, "Sign in"))));
};
exports.default = EmailRegistrationForm;
